
<template>
  <div>
    <div class="zshc">
      <div class="zshclc">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in tabList"
            :key="index"
            :label="item.label"
            :name="item.name"
          >
            <div class="neirong">
              <div class="header">
                <el-form
                  :model="formInline"
                  class="demo-form-inline"
                  style="display: flex; height: 39px"
                  label-width="90px"
                  label-position="left"
                >
                  <el-form-item label="证书类型:">
                    <el-select v-model="formInline.zslx">
                      <el-option value="G" label="购买证" />
                      <el-option value="J" label="进口核查证" />
                      <el-option value="D" label="药品证" />
                      <el-option value="T" label="调剂证" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="证书编号:">
                    <el-input
                      v-model="formInline.zsbh"
                      placeholder="请输入"
                    />
                  </el-form-item>
                  <el-form-item
                    v-show="activeName != 'first'"
                    label="核查状态:"
                  >
                    <el-select
                      v-model="formInline.hczt"
                      placeholder="请选择"
                      @change="test"
                    >
                      <el-option
                        v-for="(item, key) in statusList"
                        :key="key"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>

                  <el-form-item label="核发日期:">
                    <el-col :span="10">
                      <el-date-picker
                        v-model="formInline.sqKs"
                        type="date"
                        style="width: 100%"
                        placeholder="开始日期"
                        :picker-options="startTime"
                      />
                    </el-col>
                    <el-col
                      style="text-align: center"
                      class="line"
                      :span="3"
                    >-</el-col>
                    <el-col :span="10">
                      <el-date-picker
                        v-model="formInline.sqJs"
                        type="date"
                        style="width: 100%"
                        placeholder="结束日期"
                        :picker-options="endTime"
                      />
                    </el-col>
                  </el-form-item>

                  <el-form-item label-width="0px">
                    <el-button
                      type="primary"
                      style="background: #4170ff"
                      @click="search"
                    >搜索</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="cardList">
                <el-card
                  v-for="(item, i) in cardList"
                  :key="i"
                  class="box-card"
                >
                  <div slot="header" class="clearfix">
                    <span
                      :class="
                        item.hczt == '11'
                          ? 'biankuang1'
                          : item.hczt == '22'
                            ? 'biankuang2'
                            : 'biankuang3'
                      "
                    />
                    <span>证件类型: {{ types[formInline.zslx] }}</span>
                    <el-button
                      style="float: right; padding: 3px 5px"
                      type="primary"
                      plain
                      @click="ckDetail(item)"
                    >{{ cztype }}</el-button>
                  </div>
                  <div class="text item">
                    {{ "证件编号: " + item.xkzBh }}
                  </div>
                  <div class="text item">
                    {{ "有效期: " + item.yxqKs }}{{ " 至 " + item.yxqJs }}
                  </div>
                  <div class="text item">
                    {{ "申请单位: " + item.gmdwMc }}
                  </div>
                </el-card>
              </div>
              <el-pagination
                background
                style="margin-bottom: 50px; text-align: right"
                layout="prev,pager,next,jumper,total"
                :total="total"
                :page-size="16"
                :current-page.sync="currentPage"
                @current-change="handleCurrentChange"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="641px"
      :visible.sync="buttonVisible"
      center
      @close="closeDialog"
    >
      <div class="demo-image">
        <div class="block">
          <el-image
            style="width: 100px; height: 100px"
            :src="url"
            fit="fill"
            :preview-src-list="srcList"
          />
        </div>
      </div>

      <div v-if="cztype == '核查'">
        <div class="hc">
          <div v-if="hcjgdisabled" style="color: red;margin-bottom:10px">注：该证书已核销，如未发生实际交易业务，请选择不通过并注明原因。</div>
          <span>核查结果:</span>
          <el-checkbox-group v-model="checkList" @change="hyjgChange" :disabled="hcjgdisabled">
            <el-checkbox label="通过" name="check1">通过</el-checkbox>
            <el-checkbox label="不通过" name="check1">不通过</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="btgyy">
          <el-input
            v-model="btgly"
            :disabled="hyyy"
            required
            type="textarea"
            :rows="6"
            resize="none"
            placeholder="请填写不通过理由"
          />
        </div>
      </div>
      <div v-else-if="cztype == '查看'">
        <div class="ck">
          <span>核查结果:</span>
          <span :style="neirong.hczt == 11 ? styleObject1 : styleObject">{{
            neirong.hczt == 11 ? "通过" : "不通过"
          }}</span>
          <el-button
            v-show="neirong.hczt == 22"
            style="margin-left: 20px"
            size="small"
            type="primary"
            @click="updateStatus = true"
          >修改结果</el-button>
        </div>
        <div v-if="neirong.hczt != 11 && !updateStatus" class="ck">
          <span>不通过理由:</span>
          <span class="butgly">{{ neirong.hcsm }}</span>
        </div>
        <div v-if="!updateStatus" class="ck">
          <span>核查人:</span><span>{{ neirong.hcUser }}</span>
          <span>核查时间:</span><span>{{ neirong.hcDate }}</span>
        </div>
        <div v-if="updateStatus" class="hc">
          <div v-if="hcjgdisabled" style="color: red;margin-bottom:10px">注：该证书已核销，如未发生实际交易业务，请选择不通过并注明原因。</div>
          <span>核查结果:</span>
          <el-checkbox-group v-model="checkList" @change="hyjgChange" :disabled="hcjgdisabled">
            <el-checkbox label="通过" name="check1">通过</el-checkbox>
            <el-checkbox label="不通过" name="check1">不通过</el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="updateStatus" class="btgyy">
          <el-input
            v-model="btgly"
            :disabled="hyyy"
            required
            type="textarea"
            :rows="6"
            resize="none"
            placeholder="请填写不通过理由"
          />
        </div>
      </div>

      <div
        v-if="cztype == '核查' || updateStatus"
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff; width: 96px; height: 40px"
          @click="tjhcfunc"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { url1, getAccess } from '@/assets/js/common.js'

import { getGmzHcList, gmzHcUpdate } from '@/assets/js/xxhc.js'

export default {
  components: {},
  data() {
    return {
      startTime: {
        disabledDate: (time) => {
          if (this.formInline.sqJs) {
            return time.getTime() > new Date(this.formInline.sqJs).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.formInline.sqKs) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.formInline.sqKs).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      srcList: [],
      total: 0,
      currentPage: 1,
      updateStatus: false, // 是否修改核查结果
      activeName: 'first', // tab栏默认选择
      // tab栏内容
      statusList: [
        { label: '核查通过', value: '11' },
        { label: '核查不通过', value: '22' }
      ],
      tabList: [
        { label: '未核查', name: 'first' },
        { label: '已核查', name: 'second' }
      ],
      cztype: '核查', // 按钮内容
      types: {
        G: '购买证',
        J: '进口核查证',
        D: '药品证',
        T: '调剂证'
      },
      // 搜索条件
      formInline: {
        zslx: 'G',
        zjbh: '',
        sqKs: '',
        sqJs: ''
      },
      cardList: [],
      hcjgdisabled: false,
      buttonVisible: false, // 弹出框是否显示
      url: '',
      radio: '', // 存放checkbox单选的值
      checkList: ['通过'], // 单选 通过不通过
      hyyy: true, // 选择不通过显示text填写理由
      btgly: '', // 不通过理由
      neirong: {}, // 点击按钮是那些内容
      styleObject: {
        color: '#FF5516'
        // background: "#FFE0D5",
        // "border-radius": "3px",
        // border: "1px solid #FF5516",
        // padding: "4px 8px",
      },
      styleObject1: {
        color: '#00A46B'
        // background: "#E4FFF3",
        // "border-radius": "3px",
        // border: "1px solid #00A46B",
        // padding: "4px 8px",
      }
    }
  },
  created: function() {
    // 获取未核查
    this.getwhc(false)
  },
  methods: {
    test() {
      // 选择框刷新渲染
      this.$forceUpdate()
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      if (this.activeName == 'first') {
        // 获取未核查
        this.getwhc(false)
      } else {
        // 获取已核查
        this.getwhc(true)
      }
    },
    // 关闭对话框
    closeDialog() {
      this.updateStatus = false
    },
    // 获取未核查
    getwhc(type) {
      this.activeName == 'first' ? (this.formInline.hczt = '') : ''
      getGmzHcList({
        param: {
          xkzBh: this.formInline.zsbh, // 许可证编号
          hczt: this.formInline.hczt,
          zslx: this.formInline.zslx,
          isHc: type, // 是否核查(未核查 传false 已核查 传true)
          beginTime: this.formInline.sqKs, // 核查开始时间
          endTime: this.formInline.sqJs // 核查结束时间
        },
        page: this.currentPage,
        size: 16
      }).then((e) => {
        this.cardList = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // tab栏切换
    handleClick(tab, event) {
      this.cztype = this.activeName == 'first' ? '核查' : '查看'
      this.currentPage = 1
      if (this.activeName == 'first') {
        // 获取未核查
        this.getwhc(false)
      } else {
        // 获取已核查
        this.getwhc(true)
      }
    },
    // 搜索按钮
    search() {
      this.currentPage = 1
      if (this.activeName == 'first') {
        // 获取未核查
        this.getwhc(false)
      } else {
        // 获取已核查
        this.getwhc(true)
      }
    },
    // 弹窗显示
    ckDetail(data) {
      this.buttonVisible = true
      this.neirong = data
      if(this.neirong.zt != '12'){
        this.checkList = ["不通过"]
        this.hcjgdisabled = true
        this.hyyy = false
      }else{
        this.hcjgdisabled = false
        this.hyyy = true
        this.checkList = ['通过']
      }
      this.url =
        url1() +
        '/yzdservice/api/enterprise/credentials/common/downloadImg/' +
        this.neirong.xkzBh + '/' + this.neirong.id + '?access=' + getAccess()
      this.srcList = [this.url]
    },
    // 提交核查按钮
    tjhcfunc() {
      this.$confirm('是否确认提交核查?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let hczt
          if (this.checkList.slice(-1).toString() == '通过') {
            hczt = 11
          } else {
            hczt = 22
          }
          gmzHcUpdate({
            gmzId: this.neirong.id, // 购买证id
            zslx: this.formInline.zslx,
            hczt: hczt, // 核查状态("0", "未核查"),("11", "核查通过"),("22", "核查不通过");
            hcsm: this.btgly // 核查说明
          }).then((e) => {
            this.buttonVisible = false
            this.updateStatus = false // 刷新是否修改的状态
            this.$message({
              type: 'success',
              message: '提交核查成功!'
            })
            if (this.activeName == 'first') {
              // 获取未核查
              this.getwhc(false)
            } else {
              // 获取已核查
              this.getwhc(true)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 单选框切换是否显示text填写理由
    hyjgChange(value) {
      if (value.slice(-1) != '') {
        this.checkList = []
        this.radio = value.slice(-1).toString()
        this.checkList.push(value.slice(-1).toString())
      } else this.checkList.push(this.radio)
      this.hyyy = this.checkList.slice(-1).toString() == '通过'
    }
  }
}
</script>

<style lang="less" scoped>
.zshc {
  width: 95%;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 30px;
  max-width: 1574px;

  .zshclc {
    /deep/.el-tabs__header {
      width: 90%;
      max-width: 1356px;
      margin: 0 auto;

      .el-tabs__active-bar {
        width: 46px !important;
      }
      .el-tabs__nav-wrap {
        margin-bottom: 10px;
      }
      .el-tabs__item {
        height: 71px !important;
        padding-top: 43px !important;
        width: 42px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 20px;
      }
      #tab-first {
        // margin-right: 19px !important;
      }
      #tab-second {
        padding: 0 39px;
      }
    }
    /deep/.el-tabs__content {
      border-top: 11px solid #eff1f9 !important;
      .el-tab-pane {
        width: 90%;
        max-width: 1356px;
        // border: 1px solid red;
        margin: 0 auto;
        .neirong {
          .header {
            margin-top: 25px;
            margin-bottom: 43px;
            .el-form-item {
              margin-right: 20px;
            }
          }
          .cardList {
            width: 102%;
            display: flex;
            flex-wrap: wrap;
            // justify-content: space-between;
            margin-bottom: 30px;

            .box-card {
              width: 315px;
              height: 151px;
              margin-bottom: 30px;
              margin-right: 30px;
              justify-content: space-between;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              // &:nth-child(4n) {
              //   margin-right: 0px;
              // }
              .el-card__header,
              .el-card__body {
                height: 20px;
                line-height: 20px;
              }
              .el-card__header {
                border-bottom: none;
                .biankuang1 {
                  display: inline-block;
                  height: 9px;
                  border: 1px solid green !important;
                  margin-right: 7px;
                }
                .biankuang2 {
                  display: inline-block;
                  height: 9px;
                  border: 1px solid red !important;
                  margin-right: 7px;
                }
                .biankuang3 {
                  display: inline-block;
                  height: 9px;
                  border: 1px solid #6c7cff !important;
                  margin-right: 7px;
                }
              }
              .el-card__body {
                padding-top: 10px !important;
                .item {
                  padding-bottom: 10px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
    }
  }
}
/deep/.el-dialog__footer {
  padding-top: 40px;
  padding-bottom: 35px;
}
/deep/.el-dialog__body {
  padding: 0 39px;
  .el-image {
    width: 563px !important;
    height: 232px !important;
  }
  .ck {
    padding: 17px 0 0;
    &:last-child {
      padding-bottom: 33px;
    }
    .butgly {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    & > span {
      &:first-child {
        display: inline-block;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        margin-right: 10px;
      }
      &:nth-child(3) {
        margin-left: 40px;
        margin-right: 10px;
      }
    }
  }
  .hc {
    margin: 17px auto 23px;
    & > span {
      display: inline-block;
      width: 70px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      margin-right: 10px;
    }
    .el-checkbox-group {
      display: inline-block;
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #2860ec;
        border-color: #2860ec;
      }
      .el-checkbox__label {
        color: #515151;
      }
    }
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>
